import '../../../../../shared-chunks/mandatory-setter-BiXq-dpN.js';
import '@embroider/macros';
import { m as makeDictionary } from '../../../../../shared-chunks/dictionary-gc5gpyOG.js';

const fallbackViewRegistry = makeDictionary(null);

export { fallbackViewRegistry as default };
